<script>
		
</script>

<main>
	<h1>Our Team</h1>
	<hr>
	<br>
	<p>Our office serves adults, children and the elderly with special concerns. We accept most major insurance plans. For your convenience, we accept debit/credit, checks and cash.</p>
	
	<b>We look forward to working with you, give us a call to set up your appointment today!</b>
	<br><br><br>
	<div class="doctor">
		<div class="left-image">
			<img src="/assets/YoungKangDDS.jpg" alt="Young S. Kang D.D.S."/>
		</div>
		<div class="right-text">
			<h2>Young S. Kang D.D.S.</h2>
			<p>Dr. Kang was awarded his Doctor of Dental Surgery from Marquette University School of Dentistry in 1999.</p>
			<br>
			<p>He has been practicing Dentistry for over fifteen years in Shoreline, Washington. His professional interest include: cosmetic dentistry, oral surgery, implantology and orthodontic dentistry.</p>
			<br>
			<p>He makes it a priority to keep current with all dental technologies and techniques by attending many continuing education courses.</p>
			<br>
			<p>Dr. Kang is a long time resident of Washington State.  In his spare time, he enjoys spending time with his family.</p>
		</div>
	</div>
	
	

</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}

	.doctor {
		background-color: aliceblue;
		padding: 2em 2em;
		border-radius: 15px;
		text-align: left;
	}

	.doctor::after{
		content:"";
		display:block;
		clear:both;
	}
	.right-text{
		width:50%;
		float:right;
	}
	.left-image{
		float:left;
		width:50%;
		text-align: center;
	}
	.left-image img{
		max-width:100%;
		position: relative;
		top: 50%;
		transform: translateY(30%);
		

	}

</style>